import { defineMessage } from 'react-intl';

export const monthMessages = defineMessage<{ readonly month: string }>({
  defaultMessage:
    '{month, select, 0 {January} 1 {February} 2 {March} 3 {April} 4 {May} 5 {June} 6 {July} 7 {August} 8 {September} 9 {October} 10 {November} 11 {December} january {January} february {February} march {March} april {April} may {May} june {June} july {July} august {August} september {September} october {October} november {November} december {December} other {}}',
  description:
    'Localized month name. Accepts a numeric index (0=January … 11=December) or a lowercase name.',
});

export const weekdayMessages = defineMessage<{ readonly weekday: string }>({
  defaultMessage:
    '{weekday, select, 0 {Sunday} 1 {Monday} 2 {Tuesday} 3 {Wednesday} 4 {Thursday} 5 {Friday} 6 {Saturday} sunday {Sunday} monday {Monday} tuesday {Tuesday} wednesday {Wednesday} thursday {Thursday} friday {Friday} saturday {Saturday} other {}}',
  description:
    'Localized weekday name. Accepts a numeric index (0=Sunday … 6=Saturday) or a lowercase name.',
});
